module.exports = __webpack_public_path__ + "img/vehicle_partner.856df760.svg";